export default __webpack_public_path__ + "static/media/logo_ifce.f0f26079.svg";